import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DefaultCard from '../../components/default/DefaultCard';

interface LocationState {
    paymentUrl?: string;
    orderId?: string;
}

const PaymentRedirect: React.FC = () => {
    const location = useLocation<LocationState>();
    const [countdown, setCountdown] = useState(3);
    const [error, setError] = useState<string | null>(null);
    
    const paymentUrl = location.state?.paymentUrl;
    const orderId = location.state?.orderId;

    useEffect(() => {
        if (!paymentUrl) {
            setError('No se encontró la URL de pago');
            return;
        }

        // Countdown antes de redirigir
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    // Redirigir a Flow
                    window.location.href = paymentUrl;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [paymentUrl]);

    const handleManualRedirect = () => {
        if (paymentUrl) {
            window.location.href = paymentUrl;
        }
    };

    if (error) {
        return (
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <DefaultCard>
                            <div className="text-center py-5">
                                <div className="alert alert-danger">
                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                    {error}
                                </div>
                                <button 
                                    className="btn btn-primary"
                                    onClick={() => window.history.back()}
                                >
                                    Volver
                                </button>
                            </div>
                        </DefaultCard>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <DefaultCard>
                        <div className="text-center py-5">
                            <div className="mb-4">
                                <div className="spinner-border text-primary mb-3" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                                <h4 className="text-primary">Redirigiendo...</h4>
                                <p className="text-muted">
                                    Serás redirigido a Flow para completar el pago
                                </p>
                            </div>
                            
                            {orderId && (
                                <div className="alert alert-info mb-4">
                                    <strong>Orden:</strong> {orderId}
                                </div>
                            )}
                            
                            <div className="mb-4">
                                <div className="progress" style={{ height: '6px' }}>
                                    <div 
                                        className="progress-bar bg-primary" 
                                        style={{ 
                                            width: `${((3 - countdown) / 3) * 100}%`,
                                            transition: 'width 1s ease-in-out'
                                        }}
                                    ></div>
                                </div>
                                <small className="text-muted">
                                    Redirigiendo en {countdown} segundo{countdown !== 1 ? 's' : ''}...
                                </small>
                            </div>
                            
                            <div className="alert alert-warning">
                                <i className="fas fa-info-circle me-2"></i>
                                <strong>Importante:</strong> No cierres esta ventana hasta completar el pago
                            </div>
                            
                            <button 
                                className="btn btn-primary"
                                onClick={handleManualRedirect}
                                disabled={countdown > 0}
                            >
                                {countdown > 0 ? `Esperando... (${countdown})` : 'Ir a Flow ahora'}
                            </button>
                        </div>
                    </DefaultCard>
                </div>
            </div>
        </div>
    );
};

export default PaymentRedirect;
